import { IColorStyle } from '../models/index.js';
export const colorStyle: IColorStyle = {
	children: {
		wrapper: {
			width: '10px',
		},
	},
};
